import { useEffect } from 'react';

interface ITo {
  pathname: string;
}

interface IProps {
  to: string | ITo;
}

const CustomRedirect = ({ to }: IProps) => {
  const withHistory = typeof to === 'object';

  useEffect(() => {
    const path = withHistory ? to.pathname : to;

    window.location.replace(path);
  }, [to]);

  return null;
};

export default CustomRedirect;
